// Planes de GUIA. Nombres decididos por An (17/10/2026).
// Propuesta del 18/10/2026, aprobada por An para seguir («5 propone»); ajustable. No hay precios publicados. Los módulos (ManyChat en Instagram, tiendas) son los que An definió; no se automatiza WhatsApp.
// El Biónico viene de lo que An dijo: tecnología integrada a la empresa desde la estrategia, a medida.

export const VERSION_REGLAS = 'r1';

export const PLANES = [
  {
    id: 'digital',
    nombre: 'Plan Digital',
    resumen: 'Tu negocio ordenado y visible en lo digital.',
    items: [
      'Una web propia, pensada para que te encuentren en Google y en la IA',
      'Tus planillas y archivos reunidos en una pantalla que se comparte',
      'Una tienda conectada, si vendés online',
    ],
  },
  {
    id: 'ia',
    nombre: 'Plan IA',
    resumen: 'Asistentes de IA que conocen cómo trabajás.',
    items: [
      'Primero se analiza un proceso real de tu negocio',
      'Se arman habilidades de IA pensadas para tu estructura',
      'Tu equipo aprende a usarlas y quedan funcionando',
      'Ampliaciones: respuestas en Instagram con ManyChat y conexión con tu tienda',
    ],
  },
  {
    id: 'bionico',
    nombre: 'Plan Biónico',
    resumen: 'Tecnología integrada a la empresa desde la estrategia.',
    items: [
      'Una vertical de desarrollo del negocio, hecha a medida',
      'Trabajo de 6 a 9 meses junto a tu equipo',
      'Se conversa y se cotiza según tu empresa',
    ],
  },
];

// Qué plan se destaca y por qué. Sin motivo explicable no se destaca ninguno.
// Reglas r1 (🟠 a validar por An): ver ESPECIFICACION.md §3.
export const recomendar = (collected = {}, nodoId = '') => {
  if (nodoId.startsWith('web_result')) return { plan: 'digital', motivo: 'declarado' };
  if (collected.equipo === 'Varias áreas de la organización') return { plan: 'bionico', motivo: 'inferido' };
  if (collected.iaTarea) return { plan: 'ia', motivo: 'declarado' };
  if (collected.comoLoLleva === 'En planillas o a mano') return { plan: 'digital', motivo: 'inferido' };
  return { plan: 'neutro', motivo: 'neutro' };
};

export const MOTIVO_TEXTO = {
  declarado: 'Te lo sugerimos por lo que contaste.',
  inferido: 'Te lo sugerimos por cómo lo llevás hoy.',
};
